<template>
  <div id="app">
    <div id="container">
      <Header />
      <Home />
    </div>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";

import Header from "./views/Header.vue";
import Home from "./views/Home.vue";

export default {
  name: "app",

  components: { Header, Home },
  data() {
    return {};
  },

  created() {},
  methods: {},
};
</script>


<style>
html {
  background: #f8f8f8;
}
#app {
  font-family: "Prompt", sans-serif;
  background: #f8f8f8;
}
#header {
  margin: 0px auto;
  width: 800px;
  text-align: center;
}

#container {
  background: #000c50;
  width: 50%;
  /*height: 550px; */
  margin: 0px auto;
  padding: 10px;
}
.text-box {
  background: #000c50;
  color: white;
  padding: 6px;
  font-size: 18px;
  font-weight: bold;
}

th {
  font-size: 14px;
}
td {
  font-size: 14px;
}
@media (max-width: 575.98px) {
  #container {
    width: 100%;
  }
}
</style>
